import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['button', 'chevron']);

const ExpandableCardTheme = defineMultiStyleConfig({
  baseStyle: ({ isOpen }) => ({
    button: {
      _hover: {
        backgroundColor: 'background/hover',
      },
      _active: {
        backgroundColor: 'background/active',
      },
      alignItems: 'center',
      backgroundColor: isOpen ? 'background/secondary' : 'background/primary',
      borderBottom: isOpen ? '1px solid' : undefined,
      borderBottomColor: isOpen ? 'border/regular' : undefined,
      borderBottomEndRadius: isOpen ? undefined : '8',
      borderBottomStartRadius: isOpen ? undefined : '8',
      borderTopEndRadius: '8',
      borderTopStartRadius: '8',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    chevron: {
      transform: isOpen ? 'rotate(-180deg)' : undefined,
      transition: 'transform 0.2s ease',
    },
  }),
});

export default ExpandableCardTheme;
